<template>
  <form @submit.prevent="doSubmit">
    <ValidationProvider ref="name" rules="required|max:255" name="name" tag="div" class="w-1/2">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="name"> Name * </BaseFormLabel>
          <BaseFormInput id="name" v-model="computedName" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider rules="required|max:255" name="openingBalance" tag="div" class="w-48 mt-8">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="openingBalance"> Open Balance * </BaseFormLabel>
          <BaseFormInput
            id="openingBalance"
            v-model="computedOpeningBalance"
            type="number"
            step="0.01"
            :disabled="disabled"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider rules="decimal|min_value:0" name="creditLimit" tag="div" class="w-48 mt-8">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="creditLimit"> Credit limit </BaseFormLabel>
          <BaseFormInput
            id="creditLimit"
            v-model="computedCreditLimit"
            type="number"
            step="0.01"
            min="0"
            :disabled="disabled"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="mt-16">
      <BaseButton primary :disabled="disabled"> Submit </BaseButton>
    </div>
  </form>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    disabled: Boolean,
    name: {
      type: String,
      default: '',
    },
    openingBalance: {
      type: Number,
      default: 0,
    },
    creditLimit: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    computedName: {
      get() {
        return this.name;
      },
      set(value) {
        this.$emit('update:name', value);
      },
    },

    computedOpeningBalance: {
      get() {
        return this.openingBalance;
      },
      set(value) {
        this.$emit('update:opening-balance', value);
      },
    },

    computedCreditLimit: {
      get() {
        return this.creditLimit;
      },
      set(value) {
        this.$emit('update:credit-limit', value);
      },
    },
  },

  methods: {
    doSubmit() {
      this.$emit('submit');
    },
  },
};
</script>
